import Button from "@cmp/shared/Button/Button";
import { useDroppable } from "@dnd-kit/core";
import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect, useRef, useState } from "react";
import { FaInfo, FaPlay, FaVolumeHigh } from "react-icons/fa6";
import classes from './Target.module.css';
import Media from "../../Media/Media";
import PlayAudio from "@/components/shared/PlayAudio/PlayAudio";

const Target = ({target, setInfo_popup, children}) => {
  let isDisabled = false

  let target_items_style = {}
  const target_header_style = {}


  let classNames = [classes.Target]

  if(target.config) {
    try{
      let config = JSON.parse(target.config)
      if(config.max !== undefined) {
        if(config.max === 1) classNames.push(classes.oneElement)

        if(children[0].length >= config.max ) isDisabled = true
      }

      if(config.header_height !== undefined) {
        target_header_style.height = config.header_height
      }


    }
    catch(err) {
      console.warn("err", err)

    }
  }


  const {isOver, setNodeRef} = useDroppable({id: target.ID, disabled: isDisabled});


  if(isOver) classNames.push(classes.draggedOver)

  if(target.media) {
    target_header_style.backgroundImage = `url(${target.media})`
  }



  // HACK permet de figer la hauteur des Target une fois que le jeu est chargé, sinon elles s'agrandissent en hauteur quand on y met une image et ca complique tout avec le module de DD
  const [height, setHeight] = useState(null);
  const itemsRef = useRef(null)
  useEffect(() => {
    // setHeight(itemsRef.current.offsetHeight)
  }, []);

  if(height) target_items_style.height = height

  return (
    <div
    ref={setNodeRef}
    className={clsx(classNames)}
    >

      {(target.media || target.Text || target.infos) &&
      <div className={clsx(classes.target_header, target.media && classes.with_media)}>
        {target.media &&
        <div className={classes.media_cntr} >
          <Media path={target.media} bgColor={true} />
        </div>}

        {target.Text &&
        <div className={classes.target_name} dangerouslySetInnerHTML={{__html: target.Text}} />}

        {target.infos &&
        <Button onClick={() => setInfo_popup(target.infos)} icon={<FaInfo />} className={classes.target_info_button} />}
      </div>}


      <div ref={itemsRef} className={classes.target_items} style={target_items_style}>
        {children}
      </div>

    </div>
  )
}

export default observer(Target)